import { createContext, useState } from 'react';

const DrawerContext = createContext();

export function DrawerProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [updataDetail, setUpdataDetail] = useState(0);
  const [isSubscribeOpen, setIsSubscribeOpen] = useState('');
  const [subscribeTitle, setSubscribeTitle] = useState('');
  const [subscribeOptions, setSubscribeOptions] = useState({
    description: '',
    confirmText: '',
  });

  return (
    <DrawerContext.Provider
      value={{
        isOpen,
        setIsOpen,
        updataDetail,
        setUpdataDetail,
        isSubscribeOpen,
        setIsSubscribeOpen,
        subscribeTitle,
        setSubscribeTitle,
        subscribeOptions,
        setSubscribeOptions,
      }}>
      {children}
    </DrawerContext.Provider>
  );
}
export { DrawerContext };
